// /opt/isp_erp/frontend/src/pages/warehouse/Materiales.jsx
import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  TextField,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Tabs,
  Tab,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Divider
} from '@mui/material';
import {
  Refresh,
  Inventory,
  SwapHoriz,
  Warning,
  ArrowBack,
  PictureAsPdf,
  ExpandMore,
  ExpandLess,
  Delete  // ✅ Agregado
} from '@mui/icons-material';
import axios from '../../api/axios';

const Materiales = () => {
  const [materiales, setMateriales] = useState([]);
  const [tecnicos, setTecnicos] = useState([]);
  const [stockTecnico, setStockTecnico] = useState([]);
  const [movimientos, setMovimientos] = useState([]);
  const [alertas, setAlertas] = useState([]);
  const [stockTotal, setStockTotal] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0);

  // ✅ Selector para STOCK (solo un técnico)
  const [tecnicoStock, setTecnicoStock] = useState('');

  // ✅ Selector para PDF (múltiples técnicos)
  const [tecnicosPDF, setTecnicosPDF] = useState([]);

  // ✅ Estados para firmas - Formato HORIZONTAL
  const [firmaBodegaNombre, setFirmaBodegaNombre] = useState('');
  const [firmasTecnicos, setFirmasTecnicos] = useState({}); // {tecnicoId: "nombre"}
  const [firmaSectionOpen, setFirmaSectionOpen] = useState(false);

  const [devolverOpen, setDevolverOpen] = useState(false);
  const [movimientosOpen, setMovimientosOpen] = useState(false);
  const [devolverData, setDevolverData] = useState({
    material_id: '',
    cantidad: 0,
    observaciones: ''
  });

  // ✅ Estados para eliminar material del catálogo
  const [deleteMaterialOpen, setDeleteMaterialOpen] = useState(false);
  const [materialToDelete, setMaterialToDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  // Estados para filtros de fecha
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');

  useEffect(() => {
    cargarMateriales();
    cargarTecnicos();
    cargarAlertas();
    cargarStockTotal();
  }, []);

  // Cargar stock cuando cambia el técnico de stock
  useEffect(() => {
    if (tecnicoStock) {
      cargarStockTecnico(tecnicoStock);
    } else {
      setStockTecnico([]);
    }
  }, [tecnicoStock]);

  const cargarMateriales = async () => {
    try {
      const response = await axios.get('/warehouse/materiales');
      setMateriales(response.data || []);
    } catch (error) {
      console.error('Error cargando materiales:', error);
    } finally {
      setLoading(false);
    }
  };

  const cargarTecnicos = async () => {
    try {
      const response = await axios.get('/users');
      const tecnicosFiltrados = (response.data || []).filter(u =>
        u.roles?.some(r => r.name === 'tecnico_campo')
      );
      setTecnicos(tecnicosFiltrados);
    } catch (error) {
      console.error('Error cargando técnicos:', error);
    }
  };

  const cargarStockTecnico = async (tecnicoId) => {
    try {
      const response = await axios.get(`/warehouse/materiales/stock-tecnico/${tecnicoId}`);
      setStockTecnico(response.data || []);
    } catch (error) {
      console.error('Error cargando stock:', error);
    }
  };

  const cargarMovimientos = async () => {
    try {
      const response = await axios.get('/warehouse/materiales/movimientos');
      setMovimientos(response.data || []);
    } catch (error) {
      console.error('Error cargando movimientos:', error);
    }
  };

  const cargarAlertas = async () => {
    try {
      const response = await axios.get('/warehouse/alertas/stock-minimo');
      setAlertas(response.data || []);
    } catch (error) {
      console.error('Error cargando alertas:', error);
    }
  };

  const cargarStockTotal = async () => {
    try {
      const response = await axios.get('/warehouse/materiales/stock-total');
      setStockTotal(response.data || []);
    } catch (error) {
      console.error('Error cargando stock total:', error);
    }
  };

  const devolverMaterial = async () => {
    if (!devolverData.material_id || devolverData.cantidad <= 0) {
      alert('Complete todos los campos');
      return;
    }
    try {
      await axios.post('/warehouse/materiales/devolver-bodega', null, {
        params: {
          material_id: devolverData.material_id,
          tecnico_id: tecnicoStock,
          cantidad: devolverData.cantidad,
          observaciones: devolverData.observaciones
        }
      });
      setDevolverOpen(false);
      cargarStockTecnico(tecnicoStock);
      cargarAlertas();
      cargarStockTotal();
      setDevolverData({ material_id: '', cantidad: 0, observaciones: '' });
      alert('Material devuelto correctamente');
    } catch (error) {
      console.error('Error devolviendo material:', error);
      alert(error.response?.data?.detail || 'Error al devolver material');
    }
  };

  const verMovimientos = async () => {
    await cargarMovimientos();
    setMovimientosOpen(true);
  };

  // ✅ Función para actualizar firma de un técnico específico
  const actualizarFirmaTecnico = (tecnicoId, nombre) => {
    setFirmasTecnicos(prev => ({
      ...prev,
      [tecnicoId]: nombre
    }));
  };

  // ✅ Función para exportar PDF con múltiples técnicos y firmas
  const exportarPDF = async () => {
    if (tecnicosPDF.length === 0) {
      alert('Seleccione al menos un técnico para el reporte');
      return;
    }

    // Validar que se ingresó el nombre del personal de bodega
    if (!firmaBodegaNombre.trim()) {
      alert('Por favor, ingrese el nombre del personal de bodega que firma');
      return;
    }

    // Validar que cada técnico seleccionado tenga su firma
    const tecnicosSinFirma = tecnicosPDF.filter(id => !firmasTecnicos[id]?.trim());
    if (tecnicosSinFirma.length > 0) {
      const nombresSinFirma = tecnicosSinFirma.map(id => {
        const t = tecnicos.find(t => t.id === id);
        return t?.username || id;
      }).join(', ');
      alert(`Por favor, ingrese el nombre de los siguientes técnicos que firman:\n${nombresSinFirma}`);
      return;
    }

    try {
      // Crear lista de nombres de firmas en el mismo orden que los técnicos seleccionados
      const nombresFirmas = tecnicosPDF.map(id => firmasTecnicos[id]).join(',');

      const params = {
        tecnico_ids: tecnicosPDF.join(','),
        firma_bodega_nombre: firmaBodegaNombre,
        firma_tecnico_nombres: nombresFirmas
      };

      if (fechaDesde) {
        params.fecha_desde = fechaDesde;
      }
      if (fechaHasta) {
        params.fecha_hasta = fechaHasta;
      }

      const response = await axios.get(`/warehouse/reportes/asignacion-tecnico-pdf`, {
        params: params,
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      const nombresTecnicos = tecnicosPDF.map(id => {
        const t = tecnicos.find(t => t.id === id);
        return t?.username || id;
      }).join('_');

      let fechaSufijo = '';
      if (fechaDesde && fechaHasta) {
        fechaSufijo = `_${fechaDesde}_a_${fechaHasta}`;
      } else if (fechaDesde) {
        fechaSufijo = `_desde_${fechaDesde}`;
      } else if (fechaHasta) {
        fechaSufijo = `_hasta_${fechaHasta}`;
      }

      link.setAttribute('download', `asignacion_${nombresTecnicos}${fechaSufijo}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      // Limpiar campos después de exportar
      setFirmaBodegaNombre('');
      setFirmasTecnicos({});
      setFirmaSectionOpen(false);

      alert(`✅ PDF generado con ${tecnicosPDF.length} técnico(s) y firmas incluidas`);
    } catch (error) {
      console.error('Error exportando PDF:', error);
      alert('Error al generar el PDF');
    }
  };

  // ✅ Eliminar material del catálogo
  const handleDeleteMaterialClick = (material) => {
    setMaterialToDelete(material);
    setDeleteMaterialOpen(true);
  };

  const confirmDeleteMaterial = async () => {
    setDeleteLoading(true);
    try {
      await axios.delete(`/warehouse/materiales/${materialToDelete.id}`);
      setDeleteMaterialOpen(false);
      cargarMateriales();
      cargarAlertas();
      cargarStockTotal();
      setMaterialToDelete(null);
      alert('Material eliminado correctamente');
    } catch (error) {
      console.error('Error eliminando material:', error);
      alert(error.response?.data?.detail || 'Error al eliminar el material');
    } finally {
      setDeleteLoading(false);
    }
  };

  const getTipoColor = (tipo) => {
    const colors = { FIBRA: 'primary', CONECTOR: 'secondary', CAJA: 'success', SPLITTER: 'warning', OTRO: 'default' };
    return colors[tipo] || 'default';
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Gestión de Materiales
      </Typography>

      <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)} sx={{ mb: 2 }}>
        <Tab label="📊 Stock por Técnico" />
        <Tab label="⚠️ Alertas de Stock Bajo" />
        <Tab label="📋 Movimientos" />
        <Tab label="📦 Stock Total" />
      </Tabs>

      {/* Tab 0: Stock por Técnico */}
      {tabValue === 0 && (
        <Card>
          <CardContent>
            {/* SECCIÓN 1: Generar Reporte PDF con Múltiples Técnicos */}
            <Paper sx={{ p: 2, mb: 3, bgcolor: '#f5f5f5' }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                📄 Generar Reporte PDF
              </Typography>
              <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                Seleccione uno o varios técnicos para generar el reporte de asignación
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Técnicos para PDF</InputLabel>
                    <Select
                      multiple
                      value={tecnicosPDF}
                      onChange={(e) => {
                        setTecnicosPDF(e.target.value);
                        if (e.target.value.length > 0) {
                          setFirmaSectionOpen(true);
                        } else {
                          setFirmaSectionOpen(false);
                          setFirmaBodegaNombre('');
                          setFirmasTecnicos({});
                        }
                      }}
                      input={<OutlinedInput label="Técnicos para PDF" />}
                      renderValue={(selected) => {
                        if (selected.length === 0) return "Seleccione técnicos";
                        return selected.map(id => {
                          const t = tecnicos.find(t => t.id === id);
                          return t?.username || id;
                        }).join(', ');
                      }}
                    >
                      {tecnicos.map((t) => (
                        <MenuItem key={t.id} value={t.id}>
                          <Checkbox checked={tecnicosPDF.indexOf(t.id) > -1} />
                          <ListItemText primary={t.username || t.nombre || t.email} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Fecha Desde"
                    size="small"
                    value={fechaDesde}
                    onChange={(e) => setFechaDesde(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Fecha Hasta"
                    size="small"
                    value={fechaHasta}
                    onChange={(e) => setFechaHasta(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    startIcon={<PictureAsPdf />}
                    onClick={() => {
                      if (tecnicosPDF.length === 0) {
                        alert('Seleccione al menos un técnico');
                      } else {
                        setFirmaSectionOpen(!firmaSectionOpen);
                      }
                    }}
                    disabled={tecnicosPDF.length === 0}
                    sx={{ height: '40px' }}
                    endIcon={firmaSectionOpen ? <ExpandLess /> : <ExpandMore />}
                  >
                    {firmaSectionOpen ? 'Ocultar Firmas' : `Configurar Firmas (${tecnicosPDF.length} técnico(s))`}
                  </Button>
                </Grid>
              </Grid>

              {/* Sección de Firmas - FORMATO HORIZONTAL */}
              {firmaSectionOpen && tecnicosPDF.length > 0 && (
                <Box sx={{ mt: 3, p: 2, bgcolor: '#e8f5e9', borderRadius: 1 }}>
                  <Typography variant="subtitle2" fontWeight="bold" gutterBottom color="success.main">
                    ✍️ Datos para Firmas
                  </Typography>
                  <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                    Complete los siguientes campos para incluir en el PDF (formato horizontal para mejor espacio de firma)
                  </Typography>

                  {/* Tabla de firmas en formato HORIZONTAL */}
                  <Paper variant="outlined" sx={{ mt: 2, overflow: 'auto' }}>
                    <Box sx={{ minWidth: 800 }}>
                      {/* Encabezados */}
                      <Box sx={{ display: 'flex', bgcolor: '#e0e0e0', borderBottom: '1px solid #ccc' }}>
                        <Box sx={{ width: '25%', p: 1.5, fontWeight: 'bold', borderRight: '1px solid #ccc' }}>Rol</Box>
                        <Box sx={{ width: '35%', p: 1.5, fontWeight: 'bold', borderRight: '1px solid #ccc' }}>Nombre Completo</Box>
                        <Box sx={{ width: '40%', p: 1.5, fontWeight: 'bold' }}>Espacio para Firma</Box>
                      </Box>

                      {/* Fila: Personal de Bodega */}
                      <Box sx={{ display: 'flex', borderBottom: '1px solid #eee' }}>
                        <Box sx={{ width: '25%', p: 1.5, bgcolor: '#fafafa', borderRight: '1px solid #eee' }}>
                          <Typography variant="body2" fontWeight="bold">Personal de Bodega</Typography>
                        </Box>
                        <Box sx={{ width: '35%', p: 1, borderRight: '1px solid #eee' }}>
                          <TextField
                            fullWidth
                            placeholder="Ej: Juan Pérez - Jefe de Bodega"
                            size="small"
                            value={firmaBodegaNombre}
                            onChange={(e) => setFirmaBodegaNombre(e.target.value)}
                            variant="outlined"
                          />
                        </Box>
                        <Box sx={{ width: '40%', p: 1 }}>
                          <TextField
                            fullWidth
                            placeholder="Firma aquí después de imprimir"
                            size="small"
                            disabled
                            variant="outlined"
                            sx={{ bgcolor: '#fff9c4' }}
                            InputProps={{ readOnly: true }}
                          />
                        </Box>
                      </Box>

                      {/* Filas: Cada técnico */}
                      {tecnicosPDF.map(tecnicoId => {
                        const tecnico = tecnicos.find(t => t.id === tecnicoId);
                        return (
                          <Box key={tecnicoId} sx={{ display: 'flex', borderBottom: '1px solid #eee' }}>
                            <Box sx={{ width: '25%', p: 1.5, bgcolor: '#fafafa', borderRight: '1px solid #eee' }}>
                              <Typography variant="body2" fontWeight="bold">
                                Técnico: {tecnico?.username || tecnicoId}
                              </Typography>
                            </Box>
                            <Box sx={{ width: '35%', p: 1, borderRight: '1px solid #eee' }}>
                              <TextField
                                fullWidth
                                placeholder="Nombre completo del técnico"
                                size="small"
                                value={firmasTecnicos[tecnicoId] || ''}
                                onChange={(e) => actualizarFirmaTecnico(tecnicoId, e.target.value)}
                                variant="outlined"
                              />
                            </Box>
                            <Box sx={{ width: '40%', p: 1 }}>
                              <TextField
                                fullWidth
                                placeholder="Firma aquí después de imprimir"
                                size="small"
                                disabled
                                variant="outlined"
                                sx={{ bgcolor: '#fff9c4' }}
                                InputProps={{ readOnly: true }}
                              />
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  </Paper>

                  <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                    💡 Los campos de "Espacio para Firma" están en color amarillo para facilitar la identificación al imprimir.
                    Una vez impreso, cada persona deberá firmar manualmente en su espacio correspondiente.
                  </Typography>

                  <Divider sx={{ my: 2 }} />

                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<PictureAsPdf />}
                    onClick={exportarPDF}
                    fullWidth
                    sx={{ height: '45px' }}
                    disabled={
                      !firmaBodegaNombre.trim() ||
                      tecnicosPDF.some(id => !firmasTecnicos[id]?.trim())
                    }
                  >
                    📄 Generar PDF con Firmas (Horizontal)
                  </Button>
                </Box>
              )}
            </Paper>

            {/* SECCIÓN 2: Stock Individual por Técnico */}
            <Paper sx={{ p: 2, mb: 2, bgcolor: '#e3f2fd' }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                📊 Stock por Técnico (Individual)
              </Typography>
              <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                Seleccione un técnico para ver su stock actual de materiales
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Técnico para Stock</InputLabel>
                    <Select
                      value={tecnicoStock}
                      onChange={(e) => setTecnicoStock(e.target.value)}
                      label="Técnico para Stock"
                    >
                      <MenuItem value="">Seleccione un técnico</MenuItem>
                      {tecnicos.map(t => (
                        <MenuItem key={t.id} value={t.id}>
                          {t.username || t.nombre || t.email}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={2}>
                  <Button
                    variant="outlined"
                    onClick={() => tecnicoStock && cargarStockTecnico(tecnicoStock)}
                    startIcon={<Refresh />}
                    disabled={!tecnicoStock}
                    fullWidth
                  >
                    Actualizar
                  </Button>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Button
                    variant="contained"
                    color="warning"
                    startIcon={<Inventory />}
                    onClick={() => setDevolverOpen(true)}
                    disabled={!tecnicoStock || stockTecnico.length === 0}
                    fullWidth
                  >
                    Devolver Material
                  </Button>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Button
                    variant="outlined"
                    startIcon={<SwapHoriz />}
                    onClick={verMovimientos}
                    fullWidth
                  >
                    Ver Movimientos
                  </Button>
                </Grid>
              </Grid>
            </Paper>

            {/* Tabla de Stock */}
            {tecnicoStock && (
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                      <TableCell>Material</TableCell>
                      <TableCell>Tipo</TableCell>
                      <TableCell align="right">Cantidad</TableCell>
                      <TableCell>Unidad</TableCell>
                      <TableCell>Estado</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stockTecnico.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          No hay materiales asignados a este técnico
                        </TableCell>
                      </TableRow>
                    ) : (
                      stockTecnico.map((item) => {
                        const material = materiales.find(m => m.id === item.material_id);
                        const stockMinimo = material?.stock_minimo || 0;
                        const isLowStock = item.cantidad <= stockMinimo;
                        return (
                          <TableRow key={item.material_id} sx={{ bgcolor: isLowStock ? '#fff3e0' : 'inherit' }}>
                            <TableCell>
                              <Typography variant="body2" fontWeight="bold">
                                {item.nombre}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {item.codigo}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Chip label={item.tipo} size="small" color={getTipoColor(item.tipo)} />
                            </TableCell>
                            <TableCell align="right">
                              <Typography variant="body2" fontWeight="bold" color={isLowStock ? 'warning.main' : 'inherit'}>
                                {item.cantidad}
                              </Typography>
                            </TableCell>
                            <TableCell>{item.unidad}</TableCell>
                            <TableCell>
                              <Chip
                                label={isLowStock ? "Stock Bajo" : "Disponible"}
                                size="small"
                                color={isLowStock ? "warning" : "success"}
                                icon={isLowStock ? <Warning /> : undefined}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {!tecnicoStock && (
              <Alert severity="info">Seleccione un técnico para ver su stock de materiales</Alert>
            )}
          </CardContent>
        </Card>
      )}

      {/* Tab 1: Alertas de Stock Bajo */}
      {tabValue === 1 && (
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="h6">Alertas de Stock Mínimo</Typography>
              <Button variant="outlined" startIcon={<Refresh />} onClick={cargarAlertas}>
                Actualizar
              </Button>
            </Box>

            {alertas.length === 0 ? (
              <Alert severity="success">No hay alertas de stock bajo</Alert>
            ) : (
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Material</TableCell>
                      <TableCell>Técnico</TableCell>
                      <TableCell align="right">Stock Actual</TableCell>
                      <TableCell>Stock Mínimo</TableCell>
                      <TableCell>Unidad</TableCell>
                      <TableCell>Fecha Alerta</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {alertas.map((alerta) => (
                      <TableRow key={alerta.alerta_id} sx={{ bgcolor: '#ffebee' }}>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold">
                            {alerta.material}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {alerta.codigo}
                          </Typography>
                        </TableCell>
                        <TableCell>{alerta.tecnico_nombre}</TableCell>
                        <TableCell align="right">
                          <strong>{alerta.stock_actual}</strong>
                        </TableCell>
                        <TableCell>{alerta.stock_minimo}</TableCell>
                        <TableCell>{alerta.unidad}</TableCell>
                        <TableCell>{new Date(alerta.fecha_alerta).toLocaleString()}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </CardContent>
        </Card>
      )}

      {/* Tab 2: Movimientos */}
      {tabValue === 2 && (
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
              <Button variant="outlined" startIcon={<Refresh />} onClick={cargarMovimientos}>
                Actualizar
              </Button>
            </Box>

            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Fecha</TableCell>
                    <TableCell>Material</TableCell>
                    <TableCell>Tipo</TableCell>
                    <TableCell>Origen</TableCell>
                    <TableCell>Destino</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell>Usuario</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {movimientos.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No hay movimientos registrados
                      </TableCell>
                    </TableRow>
                  ) : (
                    movimientos.map((m) => (
                      <TableRow key={m.id}>
                        <TableCell>{new Date(m.fecha_movimiento).toLocaleString()}</TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold">
                            {m.material_nombre}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={m.tipo_movimiento}
                            size="small"
                            color={m.tipo_movimiento.includes('ASIGNACION') ? 'primary' : m.tipo_movimiento.includes('CONSUMO') ? 'error' : 'warning'}
                          />
                        </TableCell>
                        <TableCell>{m.origen}</TableCell>
                        <TableCell>{m.destino}</TableCell>
                        <TableCell align="right">
                          <strong>{m.cantidad}</strong>
                        </TableCell>
                        <TableCell>{m.usuario_nombre}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      {/* Tab 3: Stock Total - CON BOTÓN ELIMINAR */}
      {tabValue === 3 && (
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="h6">Stock Total de Materiales</Typography>
              <Button variant="outlined" startIcon={<Refresh />} onClick={cargarStockTotal}>
                Actualizar
              </Button>
            </Box>

            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                    <TableCell>Código</TableCell>
                    <TableCell>Material</TableCell>
                    <TableCell>Tipo</TableCell>
                    <TableCell align="right">Stock Total</TableCell>
                    <TableCell>Unidad</TableCell>
                    <TableCell>Stock Mínimo</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell align="center">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stockTotal.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No hay materiales registrados
                      </TableCell>
                    </TableRow>
                  ) : (
                    stockTotal.map((item) => {
                      const isLowStock = item.stock_total <= item.stock_minimo;
                      return (
                        <TableRow key={item.id} sx={{ bgcolor: isLowStock ? '#fff3e0' : 'inherit' }}>
                          <TableCell>
                            <strong>{item.codigo}</strong>
                          </TableCell>
                          <TableCell>{item.nombre}</TableCell>
                          <TableCell>
                            <Chip label={item.tipo} size="small" color={getTipoColor(item.tipo)} />
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body2" fontWeight="bold" color={isLowStock ? 'warning.main' : 'inherit'}>
                              {item.stock_total}
                            </Typography>
                          </TableCell>
                          <TableCell>{item.unidad}</TableCell>
                          <TableCell>{item.stock_minimo}</TableCell>
                          <TableCell>
                            <Chip
                              label={isLowStock ? "Stock Bajo" : "OK"}
                              size="small"
                              color={isLowStock ? "warning" : "success"}
                              icon={isLowStock ? <Warning /> : undefined}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleDeleteMaterialClick(item)}
                              title="Eliminar material del catálogo"
                              disabled={item.stock_total > 0}
                            >
                              <Delete />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      {/* Dialog Devolver Material */}
      <Dialog open={devolverOpen} onClose={() => setDevolverOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Devolver Material a Bodega</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Material</InputLabel>
                <Select
                  value={devolverData.material_id}
                  onChange={(e) => setDevolverData({ ...devolverData, material_id: e.target.value })}
                  label="Material"
                >
                  {stockTecnico.map(s => (
                    <MenuItem key={s.material_id} value={s.material_id}>
                      {s.nombre} (Stock: {s.cantidad} {s.unidad})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="number"
                label="Cantidad"
                value={devolverData.cantidad}
                onChange={(e) => setDevolverData({ ...devolverData, cantidad: parseFloat(e.target.value) })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Observaciones"
                multiline
                rows={2}
                value={devolverData.observaciones}
                onChange={(e) => setDevolverData({ ...devolverData, observaciones: e.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDevolverOpen(false)}>Cancelar</Button>
          <Button variant="contained" color="warning" onClick={devolverMaterial}>
            Devolver
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Movimientos */}
      <Dialog open={movimientosOpen} onClose={() => setMovimientosOpen(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          Historial de Movimientos
          <IconButton
            aria-label="close"
            onClick={() => setMovimientosOpen(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <ArrowBack />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Fecha</TableCell>
                  <TableCell>Material</TableCell>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Origen</TableCell>
                  <TableCell>Destino</TableCell>
                  <TableCell align="right">Cantidad</TableCell>
                  <TableCell>Usuario</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {movimientos.map((m) => (
                  <TableRow key={m.id}>
                    <TableCell>{new Date(m.fecha_movimiento).toLocaleString()}</TableCell>
                    <TableCell><strong>{m.material_nombre}</strong></TableCell>
                    <TableCell>
                      <Chip
                        label={m.tipo_movimiento}
                        size="small"
                        color={m.tipo_movimiento.includes('ASIGNACION') ? 'primary' : m.tipo_movimiento.includes('CONSUMO') ? 'error' : 'warning'}
                      />
                    </TableCell>
                    <TableCell>{m.origen}</TableCell>
                    <TableCell>{m.destino}</TableCell>
                    <TableCell align="right"><strong>{m.cantidad}</strong></TableCell>
                    <TableCell>{m.usuario_nombre}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setMovimientosOpen(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>

      {/* ✅ Dialog Confirmar Eliminación de Material */}
      <Dialog open={deleteMaterialOpen} onClose={() => !deleteLoading && setDeleteMaterialOpen(false)}>
        <DialogTitle sx={{ bgcolor: '#ffebee', color: '#c62828' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Delete /> Confirmar Eliminación
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Alert severity="warning" sx={{ mb: 2 }}>
              ⚠️ Esta acción eliminará el material del catálogo.
            </Alert>
            {materialToDelete && (
              <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                <Typography variant="body2">
                  <strong>Código:</strong> {materialToDelete.codigo}
                </Typography>
                <Typography variant="body2">
                  <strong>Nombre:</strong> {materialToDelete.nombre}
                </Typography>
                <Typography variant="body2">
                  <strong>Tipo:</strong> {materialToDelete.tipo}
                </Typography>
                <Typography variant="body2">
                  <strong>Stock actual:</strong> {materialToDelete.stock_total} {materialToDelete.unidad}
                </Typography>
              </Paper>
            )}
            {materialToDelete?.stock_total > 0 && (
              <Alert severity="error" sx={{ mt: 2 }}>
                ⛔ No se puede eliminar porque tiene stock asignado a técnicos ({materialToDelete.stock_total} {materialToDelete.unidad}).
                Debe devolver todo el stock primero.
              </Alert>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteMaterialOpen(false)} disabled={deleteLoading}>
            Cancelar
          </Button>
          <Button
            onClick={confirmDeleteMaterial}
            variant="contained"
            color="error"
            disabled={deleteLoading || materialToDelete?.stock_total > 0}
          >
            {deleteLoading ? 'Eliminando...' : 'Eliminar Material'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Materiales;
